import React, { useEffect, useState } from "react";
import { Radio } from "antd";
import { useDynamicFormStore } from "@stores/dynamicFormStore";
// import { fieldData } from "../fieldData";

const RadioInput = ({ options, rules, handleRulesOnValueChange, value }: any) => {
  const [selectedOption, setSelectedOption] = useState<any>(value);
  const [setIsInvalidFlag] = useDynamicFormStore((state) => [state.setIsInvalidFlag]);

  const handleRadioChange = (value: string) => {
    setSelectedOption(value);
    handleRulesOnValueChange(value);
    setIsInvalidFlag(false)
  };

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  return (
    <Radio.Group size="large" onChange={(e) => handleRadioChange(e.target.value)} value={selectedOption}>
      {options.map((option: any) => (
        <Radio key={option.id} value={option.id}>
          {option.value}
        </Radio>
      ))}
    </Radio.Group>
  );
};

export default RadioInput;
